import styled from 'styled-components';
import { StyledTableV5 } from 'components/DataTable/DataTable.style';

export const StyledTable = styled(StyledTableV5)`
  border: 1px solid ${({ theme }) => theme.borderColor};
  margin-top: 1em;
`;
